export default __webpack_public_path__ + "static/media/loading.16f3fb22.gif";